var t=["activate","mount","update"];export{t as DEFAULT_HOOKS};
